import { jsPDF } from "jspdf";
import "jspdf-autotable";

const formatReturnable = (value) => {
  if (value === null || value === undefined) return "N/A";
  return value ? "Yes" : "No";
};

const DownloadAllLedgersPdf = (rows, companyName, companyLogo, setOpenBackdrop) => {
  if (!rows || rows.length === 0) {
    alert("No data found to export!");
    return;
  }

  setOpenBackdrop?.(true);

  try {
    const doc = new jsPDF("l", "mm", "a4");
    let startY = 14;

    if (companyLogo) {
      doc.addImage(companyLogo, "PNG", 14, 10, 12, 12);
    }

    doc.setFontSize(14);
    doc.setTextColor(25, 118, 210);
    doc.text(companyName || "Company", companyLogo ? 30 : 14, 16);

    doc.setFontSize(11);
    doc.setTextColor(80);
    doc.text("All Ledger Report", companyLogo ? 30 : 14, 22);

    startY = 28;

    rows.forEach((row, index) => {
      if (index > 0 && startY > 170) {
        doc.addPage();
        startY = 14;
      }

      doc.autoTable({
        startY,
        theme: "grid",
        headStyles: { fillColor: [76, 181, 245] },
        styles: { fontSize: 8 },
        head: [[
          "S.No",
          "Transaction",
          "Name",
          "Type",
          "Reference No.",
          "Credit/Debit",
          "Month",
          "Amount",
        ]],
        body: [[
          index + 1,
          row.type || "",
          row.fname || "",
          row.entity_type || "",
          row.entity_number || "",
          Boolean(row.is_credit) ? "CREDIT" : "DEBIT",
          row.month || "",
          `₹${Number(row.amount || 0).toFixed(2)}`,
        ]],
      });

      startY = doc.lastAutoTable.finalY + 3;

      if (Array.isArray(row.items) && row.items.length > 0) {
        doc.setDrawColor(180);
        doc.setLineWidth(0.2);
        doc.roundedRect(14, startY - 2, 267, 6 + row.items.length * 6 + 4, 2, 2);

        doc.autoTable({
          startY: startY + 1,
          margin: { left: 16, right: 20 },
          theme: "plain",
          styles: { fontSize: 7, cellPadding: 1.5 },
          headStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0] },
          head: [["Item", "Qty", "Rate", "Amount", "Returnable"]],
          body: row.items.map((item) => [
            item.itemname || "N/A",
            item.qty ?? 0,
            `₹${Number(item.rate || 0).toFixed(2)}`,
            `₹${Number(item.amount || 0).toFixed(2)}`,
            formatReturnable(item.is_returnable),
          ]),
          columnStyles: {
            1: { halign: "left" },
            2: { halign: "left" },
            3: { halign: "left" },
            4: { halign: "left" },
          },
        });

        startY = doc.lastAutoTable.finalY + 8;
      } else {
        startY += 4;
      }
    });

    doc.save(`All_Ledgers_${Date.now()}.pdf`);
  } catch (error) {
    console.error("PDF Generation Error:", error);
    alert("Something went wrong while generating PDF");
  } finally {
    setOpenBackdrop?.(false);
  }
};

export default DownloadAllLedgersPdf;
